import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  fetchComposers,
  fetchComposer,
  updateComposer,
  type UpdateComposerInput,
} from '@/services/api/composers'
import { dataKeys } from './useDashboardData'

export const composerKeys = {
  all: ['composers'] as const,
  lists: () => [...composerKeys.all, 'list'] as const,
  list: () => [...composerKeys.lists()] as const,
  details: () => [...composerKeys.all, 'detail'] as const,
  detail: (id: number) => [...composerKeys.details(), id] as const,
}

export function useComposers() {
  return useQuery({
    queryKey: composerKeys.list(),
    queryFn: fetchComposers,
  })
}

export function useComposer(id: number) {
  return useQuery({
    queryKey: composerKeys.detail(id),
    queryFn: () => fetchComposer(id),
    enabled: id > 0,
  })
}

export function useUpdateComposer() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: UpdateComposerInput }) =>
      updateComposer(id, input),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: composerKeys.detail(variables.id) })
      queryClient.invalidateQueries({ queryKey: composerKeys.lists() })
      queryClient.invalidateQueries({ queryKey: dataKeys.dashboard() })
    },
  })
}
